import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  POST_ENQUIRE_SERVICE_REQUEST: '',
  POST_ENQUIRE_SERVICE_SUCCESS: '',
  POST_ENQUIRE_SERVICE_FAILURE: '',

};

types = setStoreTypeValues(types, 'authEnquireService');

export default types;
